import type { Dict } from "@/types/dict";
import type { FormInstance } from "./instance";

export class FormScope {
  static currentForm: FormInstance<any, any, any> | null = null;

  static getCurrent<State extends Dict, ComputedData extends Dict = Dict, ExternalData extends Dict = Dict>(): (FormInstance<State, ComputedData, ExternalData> | null) {
    if (!FormScope.currentForm) return null;
    return FormScope.currentForm;
  }
}
